module.exports = __webpack_public_path__ + "static/media/img-porter-agenda.81d4c0dd.png";